// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1Wqg7","actions":"GroupTable_actions__3rqkK","deleteModalFooter":"GroupTable_deleteModalFooter__Ca0LA"};